// What the production progress board flags. Mirrors
// TMSWeb.Common.Constants.ProductionProgressExceptions.
export enum ProductionProgressExceptions {
  overdue = 'Overdue',
  straggler = 'Straggler',
  outOfSequence = 'OutOfSequence',
  late = 'Late',
  willBeLate = 'WillBeLate',
}
